import './priceManagement.css'

import { Vertical } from '@gravitate-js/excalibrr'
import React from 'react'

import { useSupplyManagementContext } from '../contexts/SupplyManagementContext'
import { SupplyDirectoryGrid } from './components/Grid'
import { PriceHistoryDrawer } from './components/PriceHistoryDrawer'
import usePriceHistoryDrawer from './components/PriceHistoryDrawer/hooks/usePriceHistoryDrawer'

export function SupplyDirectory() {
  const { headerFilters } = useSupplyManagementContext()
  const priceHistoryDrawerHook = usePriceHistoryDrawer(headerFilters.filter?.as_of)

  return (
    <Vertical flex={1}>
      <SupplyDirectoryGrid openHistoryDrawer={priceHistoryDrawerHook.showDrawer} />
      <PriceHistoryDrawer priceHistoryDrawerHook={priceHistoryDrawerHook} />
    </Vertical>
  )
}
